import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourceService } from './resource-service';
import { HistoryLog } from '../models/history-log';

@Injectable({
  providedIn: 'root',
})
export class HistoryLogsService extends ResourceService<HistoryLog> {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, '/api/history-log');
  }
}
